import React, { useState } from 'react';
import { apiUrl } from '../config/api';

interface VacationRequestFormProps {
  onSuccess?: () => void;
  targetUserId?: string;
}

const VacationRequestForm: React.FC<VacationRequestFormProps> = ({ onSuccess, targetUserId }) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [dayFraction, setDayFraction] = useState<'1' | '0.5'>('1');
  const [comment, setComment] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    const token = localStorage.getItem('token');
    if (!token) {
      setError('Nicht eingeloggt.');
      return;
    }

    try {
      const res = await fetch(apiUrl('/api/vacation-requests'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          startDate,
          endDate,
          comment,
          dayFraction: Number(dayFraction),
          ...(targetUserId ? { userId: targetUserId } : {}),
        })
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.message || 'Fehler beim Antrag');
      }

      setMessage('Antrag erfolgreich gestellt.');
      setStartDate('');
      setEndDate('');
      setDayFraction('1');
      setComment('');
      if (onSuccess) onSuccess();
    } catch (err: any) {
      setError(err.message || 'Unbekannter Fehler');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-3">
      <div className="mb-3">
        <label className="form-label">Startdatum</label>
        <input
          type="date"
          className="form-control"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Enddatum</label>
        <input
          type="date"
          className="form-control"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Umfang pro Tag</label>
        <select
          className="form-select"
          value={dayFraction}
          onChange={(e) => setDayFraction(e.target.value as '1' | '0.5')}
          required
        >
          <option value="1">Ganzer Tag</option>
          <option value="0.5">Halber Tag</option>
        </select>
      </div>
      <div className="mb-3">
        <label className="form-label">Kommentar</label>
        <textarea
          className="form-control"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </div>
      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      <button type="submit" className="btn btn-primary">Antrag stellen</button>
    </form>
  );
};

export default VacationRequestForm;
